export const darkTheme = {
    colors: {
        background: '#232323',
        backgroundSecondary: '#414141',
        text: '#F5F5F8',
        textSecondary: '#d1d1d1',
        warning: '#F87433',
        info: '#007bff',
        brand: '#13293d',
        danger: '#FF0000',
        loading: '#247BA0',
        success: '#4caf50',
        lightGray: '#DDDDDD',
        extralightGray: '#e7e7e7',
        lightGrayOpacity: '#DDDDDD40',
        white: '#ffffff',
        black: '#000000',
        schedule: '#8B72BE',
        pending: '#D4764E',
        working: '#5290A8',
        delivery: '#5D9B76',
    }
};

export const lightTheme = {
    colors: {
        background: '#f4f4f4',
        backgroundSecondary: '#ffffff',
        text: '#000000',
        textSecondary: '#515151',
        warning: '#F87433',
        info: '#007bff',
        brand: '#13293d',
        danger: '#FF0000',
        loading: '#247BA0',
        success: '#4caf50',
        lightGray: '#DDDDDD',
        extralightGray: '#e7e7e7',
        lightGrayOpacity: '#DDDDDDff',
        white: '#ffffff',
        black: '#000000',
        schedule: '#8B72BE',
        pending: '#D4764E',
        working: '#5290A8',
        delivery: '#5D9B76',
    }
};

